export default "__VITE_ASSET__SvL_4Jpi__"